"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.start = start;
var _reactBulletApp = _interopRequireDefault(require("@stubhub/react-bullet-app"));
var _app = _interopRequireDefault(require("./app"));
function start(_ref) {
  var layout = _ref.layout,
    getRoutes = _ref.getRoutes,
    isFallbackApp = _ref.isFallbackApp;
  if (layout) {
    _app["default"].defaultProps = {
      Layout: layout
    };
  }
  return (0, _reactBulletApp["default"])(_app["default"], {
    getRoutes: getRoutes,
    isFallbackApp: isFallbackApp
  });
}